var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBalloon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76389 12.1587H9.36337L8.22985 13.1656C8.11006 13.2795 8.04475 13.4302 8.04772 13.586C8.05068 13.7418 8.12167 13.8905 8.24571 14.0007C8.36976 14.1108 8.53714 14.1739 8.71254 14.1765C8.88794 14.1792 9.05763 14.1212 9.18579 14.0148L9.56363 13.6791L9.94147 14.0148C10.0683 14.1273 10.2402 14.1905 10.4194 14.1905C10.5987 14.1905 10.7706 14.1273 10.8974 14.0148C11.0241 13.9021 11.0952 13.7494 11.0952 13.5902C11.0952 13.431 11.0241 13.2783 10.8974 13.1656L9.76389 12.1587Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59343 9.70658C8.3121 10.8008 9.03837 11.1962 9.50326 11.1962C9.96814 11.1962 10.6944 10.8008 11.4131 9.70658C12.0975 8.6645 12.4827 7.40402 12.4827 6.53352C12.4827 5.73201 12.1663 4.96537 11.6064 4.40172C11.0469 3.83841 10.2901 3.52381 9.50326 3.52381C8.71636 3.52381 7.95962 3.83841 7.40007 4.40172C6.84018 4.96538 6.52381 5.73201 6.52381 6.53352C6.52381 7.40402 6.90899 8.6645 7.59343 9.70658ZM9.50326 12.72C7.0183 12.72 5 8.97717 5 6.53352C5 5.33115 5.47445 4.17804 6.31897 3.32784C7.1635 2.47764 8.30892 2 9.50326 2C10.6976 2 11.843 2.47764 12.6875 3.32784C13.5321 4.17804 14.0065 5.33115 14.0065 6.53352C14.0065 8.97717 11.9882 12.72 9.50326 12.72Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57143 15C9.99222 15 10.3333 15.3411 10.3333 15.7619V17.2381C10.3333 17.6589 9.99222 18 9.57143 18C9.15064 18 8.80952 17.6589 8.80952 17.2381V15.7619C8.80952 15.3411 9.15064 15 9.57143 15Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.84769d5f.svg";
export { ForwardRef as ReactComponent };